<template>
  <b-row>
    <b-col>
      <p>
        <span style="color: red; margin-left: 10px"><v-icon name="exclamation" scale="0.8" /> Pas de caractères spéciaux dans le nom du challenge (+,-,?,...)</span>
      </p>
      <div class="challenge_item" v-for="(course, index_course) in coursesCumul" :key="index_course">
        <p>
          Nom de la course : {{ course.nom }} <b-button class="delete_challenge_btn" size="sm" @click="deleteCourse(index_course)"><v-icon name="times"></v-icon> Supprimer</b-button>
        </p>
        <p>
          Points intermédiaires de la course :
          <span v-for="(inter, index_inter) in course.intermediaires" :key="index_inter" class="course_in_challenge">{{ inter }}</span>
        </p>
      </div>
      <div class="form_add_challenge">
        <p>
          <b>Créer une course de cumul d'intermédiaires en équipe</b>
        </p>
        <b-row>
          <b-col md="4">
            <b-form-input v-model="temp_course.nom" size="sm" placeholder="Nom du cumul (optionnel)"></b-form-input>
          </b-col>
          <b-col md="8">
            <p class="container_list_courses_challenge">
              Points intermédiaires :
              <span v-for="(intermediaire, index_inter) in temp_course.intermediaires" :key="index_inter" class="course_in_challenge">
                {{ intermediaire }}
                <b-button @click="removeInterFromTemp(index_inter)"><v-icon name="times" scale="0.5"></v-icon></b-button>
              </span>
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>
              <b-button size="sm" v-for="(point_inter, index_point_inter) in list_points_inter" :key="index_point_inter" class="course_to_add_challenge" @click="addInterToCourse(index_point_inter)">
                <v-icon name="plus" scale="0.5"></v-icon>
                {{ point_inter }}
              </b-button>
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p style="text-align: right"><b-button size="sm" @click="addTempCourse">Ajouter la course</b-button></p>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ["raw_resultats", "raw_courses_cumul_equipe"],
  data() {
    return {
      temp_course: { nom: "", intermediaires: [] },
      list_points_inter: [],
      coursesCumul: [],
    };
  },
  watch: {
    coursesCumul() {
      this.$emit("updateCoursesCumulEquipe", this.coursesCumul);
    },
  },
  methods: {
    deleteCourse(index) {
      this.coursesCumul.splice(index, 1);
    },
    removeInterFromTemp(index) {
      this.temp_course.intermediaires.splice(index, 1);
    },
    addInterToCourse(index) {
      this.temp_course.intermediaires.push(this.list_points_inter[index]);
    },
    addTempCourse() {
      if (this.temp_course.nom === "") {
        this.temp_course.nom = "Cumul ";
        for (var i = 0; i < this.temp_course.intermediaires.length; i++) {
          this.temp_course.nom += this.temp_course.intermediaires[i];
          if (i < this.temp_course.intermediaires.length - 1) {
            this.temp_course.nom += " - ";
          }
        }
      }
      this.coursesCumul.push(JSON.parse(JSON.stringify(this.temp_course)));
      this.temp_course.nom = "";
      this.temp_course.intermediaires = [];
    },

    findPassageInterm() {
      var first_row = this.raw_resultats[0];
      var list_keys = Object.keys(first_row);
      for (var i = 0; i < list_keys.length; i++) {
        if (list_keys[i].includes("Interm (")) {
          this.list_points_inter.push(list_keys[i]);
        }
      }
    },
  },
  created() {
    if (this.raw_courses_cumul_equipe && this.raw_courses_cumul_equipe.length > 0) {
      this.coursesCumul = this.raw_courses_cumul_equipe;
    }
    this.findPassageInterm();
  },
};
</script>

<style scoped>
.challenge_item,
.form_add_challenge {
  border: 1px solid #999;
  background-color: #e7e7e7;
  padding: 5px;
  margin: 5px 0;
}

.delete_challenge_btn {
  background-color: rgb(109, 4, 4) !important;
  border: 1px solid rgb(109, 4, 4) !important;
  float: right;
}
.delete_challenge_btn:hover {
  background-color: white !important;
  color: rgb(109, 4, 4) !important;
}

.course_in_challenge {
  background-color: #fdfdfd;
  padding: 7px 10px;
  margin: 0 3px;
  border-radius: 3px;
}
.container_list_courses_challenge {
  background-color: white;
  line-height: 23px;
  padding: 5px 8px 3px 8px;
  border-radius: 3px;
  border: 1px solid #ced4da;
}
.container_list_courses_challenge .course_in_challenge {
  background-color: #e2e2e2;
  padding-right: 0 !important;
}

.course_in_challenge button {
  background-color: rgb(109, 4, 4) !important;
  border: none !important;
  padding: 2px 5px;
  margin-top: -2px;
}

.course_to_add_challenge {
  color: black !important;
  background-color: rgb(173, 243, 173) !important;
  border: 1px solid rgb(173, 243, 173) !important;
  font-size: 13px;
  margin: 0px 3px;
}
</style>